import { Button } from "@/components/ui/button"
import CloseButton from "@/pages/new-platform/components/CloseButton"
import { useNavigate } from "react-router-dom"
import { CalendlyExpert } from "../types/CalendlyExpert"
import { getGenderTitle, getRoleTitle } from "../utils/expertUtils"

const ExpertInfoDialog: React.FC<{
    expert: CalendlyExpert,
    onExpertInfoDismissClick: () => void,
}> = ({
    expert,
    onExpertInfoDismissClick,
}) => {
    const navigate = useNavigate()
        return (
            <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                <div className="w-full h-full max-w-3xl max-h-[90vh] mx-auto bg-white rounded-md shadow-lg flex flex-col py-6 px-6 overflow-hidden">

                    {/* Main Content Area */}
                    <div className="flex flex-col space-y-5 flex-grow overflow-hidden">
                        {/* HEADER */}
                        <div className="flex items-center justify-between h-[95px]">
                            <div className="w-[93px] h-[93px] rounded-full border border-solid border-border overflow-hidden flex-shrink-0">
                                <img
                                    className="w-full h-full object-cover"
                                    src={expert.calendly_data?.calendly_user?.avatar_url || "/default-avatar.png"}
                                    alt={`${expert.data.name} ${expert.data.family_name} avatar`}
                                />
                            </div>
                            <div className="flex flex-col justify-between flex-grow ml-6 h-full">
                                <div className="flex justify-end">
                                    <CloseButton onClick={onExpertInfoDismissClick} />
                                </div>
                                <div>
                                    <div className="font-bold text-xs text-gray-600">{getGenderTitle(expert.data.sex)}</div>
                                    <div className="font-bold text-lg">{expert.data.name} {expert.data.family_name}</div>
                                </div>
                                <div className="font-bold text-primary">{getRoleTitle(expert.role)}</div>
                            </div>
                        </div>

                        {/* TAGS */}
                        <div className="flex flex-wrap gap-2 max-h-[100px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-300">
                            {(expert.tags || []).map((tag, index) => (
                                <div
                                    key={index}
                                    className="rounded-[15px] font-semibold text-[12px] leading-[17px] py-2 px-4 bg-parameter-warning whitespace-nowrap"
                                >
                                    {tag}
                                </div>
                            ))}
                        </div>

                        {/* BIO */}
                        <div className="flex-grow overflow-y-auto font-normal text-gray-700 pr-1 scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-300">
                            {expert.data.bio || "Nessuna biografia disponibile."}
                        </div>
                    </div>

                    {/* FOOTER */}
                    <Button size={'lg'} onClick={() => navigate("/chat")}>
                        Chatta con {expert.data.name}
                    </Button>
                </div>
            </div>
        )
    }

export default ExpertInfoDialog
